<script setup lang="ts">
import { onMounted } from 'vue';
import { RouterView } from 'vue-router';
import { NConfigProvider, NMessageProvider, NDialogProvider, NLoadingBarProvider, darkTheme, ruRU, dateRuRU } from 'naive-ui';
import { useAuthStore } from './stores/auth.store';

const auth = useAuthStore();

const themeOverrides = {
	common: {
		primaryColor: '#4f8cff',
		primaryColorHover: '#6aa0ff',
		primaryColorPressed: '#3d72d8',
		primaryColorSuppl: '#4f8cff',
		bodyColor: '#0f1115',
		cardColor: '#161922',
		modalColor: '#1f2330',
		popoverColor: '#1f2330',
		borderColor: '#2a2f3d',
		dividerColor: '#2a2f3d',
		hoverColor: '#252938',
		fontWeightStrong: '600'
	}
};

onMounted(async () => {
	await auth.fetchMe();
});
</script>

<template>
	<NConfigProvider :theme="darkTheme" :theme-overrides="themeOverrides" :locale="ruRU" :date-locale="dateRuRU">
		<NLoadingBarProvider>
			<NDialogProvider>
				<NMessageProvider>
					<RouterView />
				</NMessageProvider>
			</NDialogProvider>
		</NLoadingBarProvider>
	</NConfigProvider>
</template>
